import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_app/_/phone-banking/$campaignId",
)({
	component: () => <Outlet />,
});
